import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

interface Props {
  content: string;
}

const MarkdownRender: React.FC<Props> = ({ content }) => {
  return (
    <div
      className="markdown-body"
      style={{ fontSize: "17px", textAlign: "justify" }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={{
          h1: ({ node, children, ...props }) => (
            <h1
              style={{
                color: "#006d75", // Màu chủ đạo mới
                borderBottom: "2px solid #e6fffb",
                paddingBottom: 15,
                marginTop: 30,
                fontSize: "26px",
                fontFamily: "'Merriweather', serif",
              }}
              {...props}
            >
              {children}
            </h1>
          ),
          h2: ({ node, children, ...props }) => (
            <h2
              style={{
                color: "#00474f",
                marginTop: 25,
                fontSize: "22px",
                fontFamily: "'Merriweather', serif",
              }}
              {...props}
            >
              {children}
            </h2>
          ),
          h3: ({ node, children, ...props }) => (
            <h3
              style={{
                color: "#874d00", // Màu nâu đất nhấn mạnh tiểu mục
                marginTop: 20,
                fontSize: "19px",
                fontStyle: "italic",
              }}
              {...props}
            >
              {children}
            </h3>
          ),
          p: ({ node, ...props }) => (
            <p style={{ marginBottom: "16px", lineHeight: "1.8" }} {...props} />
          ),
          ul: ({ node, ...props }) => (
            <ul
              style={{ paddingLeft: "25px", marginBottom: "16px" }}
              {...props}
            />
          ),
          li: ({ node, ...props }) => (
            <li style={{ marginBottom: "8px" }} {...props} />
          ),
          blockquote: ({ node, ...props }) => (
            <blockquote
              style={{
                borderLeft: "4px solid #fa8c16" /* Màu cam nhấn */,
                background: "#fff7e6",
                padding: "15px 20px",
                margin: "20px 0",
                fontStyle: "italic",
                borderRadius: "0 8px 8px 0",
                color: "#595959",
              }}
              {...props}
            />
          ),
          strong: ({ node, ...props }) => (
            <strong style={{ color: "#006d75", fontWeight: 700 }} {...props} />
          ),
          code: ({ node, ...props }) => (
            <span
              style={{
                background: "#f5f5f5",
                padding: "2px 6px",
                borderRadius: 4,
                fontFamily: "monospace",
                color: "#d63384",
              }}
              {...props}
            />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRender;
